import React from 'react';
import Router from 'next/router';

import Layout from '@pcid/components/layout';
import Link from '@pcid/link';
import oops from '@pcid/utils/oops';
import { storageManager } from '@pcid/storage-manager';
import { AutoFormattedMessage, autoFormatMessage } from '@pcid/string-utils';
import { encodeString } from '@pcid/storage-utils';

class LogoutSuccess extends React.Component {
	componentDidMount() {
		const { redirectUri } = Router.query;

		if (typeof redirectUri === 'string') {
			storageManager.clearSession();
			window.location.replace(this.getRedirectURL());
		} else {
			oops.notFound();
		}
	}

	getRedirectURL = () => {
		const { redirectUri, data } = Router.query;
		return `${redirectUri}?response=${encodeString(data)}`;
	}

	render() {
		return (
			<Layout title="page.title.loginSuccess">
				<h1 className="loginSuccess__page-heading">
					<AutoFormattedMessage id="page.loginSuccess.heading" />
				</h1>
				<hr className="loginSuccess__divider" />
				<p className="loginSuccess__description">
					<AutoFormattedMessage id="page.logoutSuccess.successDescription" />
				</p>
				<Link
					theme="button"
					display="block"
					className="loginSuccess__button--submit"
					to={this.getRedirectURL()}
					aria-label={autoFormatMessage('page.loginSuccess.submit.ariaLabel')}
					onClick={() => {
						storageManager.clearSession();
					}}
				>
					<AutoFormattedMessage
						id="page.logoutSuccess.completeLogoutButton"
					/>
				</Link>
			</Layout>
		);
	}
}

export default LogoutSuccess;
